<mat-accordion>
  <mat-expansion-panel [expanded]="isExpandedCommunityDetails">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div>
          <div class="residential-accordion__title">{{'residential.community_details.title' | translate }}<span *ngIf="!isExpandedCommunityDetails"> ({{'residential.community_details.optional' | translate }})</span>:</div>
          <div class="residential-accordion__description">{{'residential.community_details.description' | translate }}</div>
        </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
      <mat-form-field appearance="outline">
        <mat-label>{{'residential.community_details.number_units_label' | translate}}</mat-label>
        <input matInput type="number" [formControl]="f['number_of_units']">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'residential.community_details.gated_label' | translate}}</mat-label>
        <mat-select formControlName="gated">
          <mat-option *ngFor="let answer of gatedAnswers" [value]="answer.value">{{ answer.label | translate }}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="outline">
        <mat-label>{{'residential.community_details.year_built_label' | translate}}</mat-label>
        <input matInput type="number" [formControl]="f['year_built']">
        <mat-error *ngIf="f['year_built'].errors">
          {{ f['year_built'] | errorMsg: ('residential.community_details.year_built_field' | translate)}}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'residential.community_details.years_managed_label' | translate}}</mat-label>
        <input matInput type="number" [formControl]="f['years_professionally_managed']">
      </mat-form-field>
    </form>
  </mat-expansion-panel>
</mat-accordion>
